import {Group} from './../../balancesheet/types'
import axios, {AxiosResponse} from 'axios'

const API_URL = process.env.REACT_APP_THEME_API_URL

export interface AgingReportData {
  ledgerId: number
  parentLedger: string
  subLedger: string
  // lastTransactionDate?: string
  // transactionAmount: number
  setOffAmount: number
  totalInvoiceAmount: number
  pendingInvoices: number
  totalOutstanding: number
  // naReferenceAmount: number
  advances: number
  noReference: number
  '0-15 days': number
  '16-30 days': number
  '31-60 days': number
  '61-90 days': number
  '91-180 days': number
  '>180 days': number
  actions?: any
}

export interface LedgerResponse {
  ledger_id: number
  company_id: number
  group_id: number
  parent_group: string
  sub_group: string | null
  parent_ledger: string | null
  sub_ledger: string | null
  ledger_code: string
  is_parent_ledger: boolean
  currency: string
  email: string | null
  person_name: string | null
  address: string | null
  state: string | null
  country: string | null
  postal_code: string | null
  account_number: string | null
  branch_name: string | null
  ifsc_code: string | null
  opening_balance: number
  period_debit: number
  period_credit: number
  closing_balance: number
  total_debit: number
  total_credit: number
  as_on_date: string | null
  transaction_type: string | null
  previous_sub_ledger: string | null
}

export interface GroupResponse {
  group_id: number
  company_id: number
  parent_group: string
  sub_group: string | null
  classification: string
  is_parent_group: Boolean
  is_default_group: Boolean
}
export interface AgingReportResponseBody {
  parent_ledger: string
  sub_ledger: string | null
  total_invoice_amount: number
  total_set_off_amount: number
  pending_invoices: number
  total_outstanding: number
  pa_0_15_days: number
  pa_16_30_days: number
  pa_31_60_days: number
  pa_61_90_days: number
  pa_91_180_days: number
  pa_gt_180_days: number
  advances: number
  no_reference: number
  ledger: LedgerResponse
  group: GroupResponse
}

export const getAgingReport = async (
  company_id: string,
  fy_name: string,
  to_date: string,
  report_type: 'receivables' | 'payables'
): Promise<AgingReportData[] | undefined> => {
  try {
    const response = await axios.post(
      `${API_URL}/accounting/transaction/report/aging/`,
      {
        company_id,
        fy_name,
        from_date: null,
        to_date,
        report_name: 'aging_report',
        report_type,
      },
      {
        validateStatus: () => true,
      }
    )

    if (!response) {
      throw new Error('Internal Server Error')
    }

    if (response.data && response.data.status && response.data.status === 'error') {
      throw new Error(response.data.message)
    }
    return response.data.map((tr: AgingReportResponseBody) => ({
      ledgerId: tr.ledger.ledger_id,
      parentLedger: tr.ledger.parent_ledger,
      subLedger: tr.ledger.sub_ledger,
      // lastTransactionDate: tr.last_transaction_date,
      totalInvoiceAmount: tr.total_invoice_amount,
      // transactionAmount: tr.transaction_amount,
      setOffAmount: tr.total_set_off_amount,
      pendingInvoices: tr.pending_invoices,
      totalOutstanding: tr.total_outstanding,
      // naReferenceAmount: tr.na_reference_amount,
      '0-15 days': tr.pa_0_15_days,
      '16-30 days': tr.pa_16_30_days,
      '31-60 days': tr.pa_31_60_days,
      '61-90 days': tr.pa_61_90_days,
      '91-180 days': tr.pa_91_180_days,
      '>180 days': tr.pa_gt_180_days,
      advances: tr.advances,
      noReference: tr.no_reference,
    }))
  } catch (err: any) {
    if (err) throw err
  }
}
